// src/lib/preload.js — the generated data that components read SYNCHRONOUSLY.
//
// Most data loads lazily: a page calls loadData() in a created() hook and shows a
// loading state (lib/dataStore.js). A few files can't work that way. rosterStats
// drives the grade on every unit card, the bracket's team grades, and the
// new-tournament notifier on every page, and they (and classIndex, statsMonthly, …)
// are read straight from computed properties. They used to be bundled JSON, there
// the instant a module loaded.
//
// Now they live on S3 like everything else, and main.js loads what the page needs
// (CORE for every page, plus that page's `data` list in src/routes.js) BEFORE the
// app mounts. These exports are live bindings: preload() fills them in, and
// components read them exactly as they read the bundled JSON, with no loading
// states anywhere.
//
// Reading one the current page didn't preload throws, rather than quietly rendering
// an empty table: add it to that page's `data` list in src/routes.js.

import { loadData } from './dataStore.js';

function unloaded(name) {
  return new Proxy({}, {
    get(_, key) {
      // Probes from await, Vue, devtools and the console aren't reads of the data.
      if (typeof key === 'symbol' || key === 'then' || key === 'toJSON' || String(key).startsWith('__v_')) return undefined;
      throw new Error(`${name}.json was read before it loaded; add it to this page's \`data\` in src/routes.js`);
    },
  });
}

export let rosterStats = unloaded('rosterStats');
export let classIndex = unloaded('classIndex');
export let classIndexGender = unloaded('classIndexGender');
export let statsMonthly = unloaded('statsMonthly');
export let tournamentStats = unloaded('tournamentStats');
export let teamRankings = unloaded('teamRankings');
export let mapStats = unloaded('mapStats');
export let seasonUnits = unloaded('seasonUnits');
export let blueMagicSets = unloaded('blueMagicSets');
// The chat set its pages read synchronously (built daily on the refresh box by tools/chat/).
export let chatVolume = unloaded('chatVolume');
export let chatMeta = unloaded('chatMeta');
export let chatChatters = unloaded('chatChatters');
export let chatLexicon = unloaded('chatLexicon');
export let chatSubmissions = unloaded('chatSubmissions');
export let copypasta = unloaded('copypasta');
export let carpetBible = unloaded('carpetBible');

// Reassigning an exported `let` updates it for every module that imported it.
const SET = {
  rosterStats: (d) => { rosterStats = d; },
  classIndex: (d) => { classIndex = d; },
  classIndexGender: (d) => { classIndexGender = d; },
  statsMonthly: (d) => { statsMonthly = d; },
  tournamentStats: (d) => { tournamentStats = d; },
  teamRankings: (d) => { teamRankings = d; },
  mapStats: (d) => { mapStats = d; },
  seasonUnits: (d) => { seasonUnits = d; },
  blueMagicSets: (d) => { blueMagicSets = d; },
  chatVolume: (d) => { chatVolume = d; },
  chatMeta: (d) => { chatMeta = d; },
  chatChatters: (d) => { chatChatters = d; },
  chatLexicon: (d) => { chatLexicon = d; },
  chatSubmissions: (d) => { chatSubmissions = d; },
  copypasta: (d) => { copypasta = d; },
  carpetBible: (d) => { carpetBible = d; },
};

// Every page needs these: TournamentNotifier grades an entrant's unit on all of them.
export const CORE = ['rosterStats', 'classIndex'];

export function preload(names) {
  return Promise.all([...new Set(names)].map((n) => {
    if (!SET[n]) return Promise.reject(new Error(`preload: no such data file '${n}'`));
    return loadData(`${n}.json`).then(SET[n]);
  }));
}
